type EventName = string;
type EventCategory = string;

export const trackEvent = (eventName: EventName, eventCategory: EventCategory): void => {
  window.gtag('event', eventName, {
    event_category_click: eventCategory
  });
};
